import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import { MissionLifecycleFragmentFragment, MissionLifecycleState } from "@/gql"
import MissionAction from "./MissionAction.vue"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import {
  ArchiveMissionMutation,
  ArchiveMissionMutationMutation,
  ArchiveMissionMutationMutationVariables,
} from "@/gql"


export default /*#__PURE__*/_defineComponent({
  __name: 'ArchiveMissionAction',
  props: {
    mission: null
  },
  setup(__props: any) {

const props = __props as {
  mission: MissionLifecycleFragmentFragment
}



const { mutate } = useMutation()
const { addSuccess, addError } = useNotification()
const isSubmitting = ref(false)

const form = ref({
  archivalReason: "",
})

const showArchiveMissionModal = ref(false)

const onConfirmArchiveMission = async () => {
  if (!form.value.archivalReason) {
    addError("Please enter a reason for archiving the mission")
    return
  }

  isSubmitting.value = true

  const result = await mutate<
    ArchiveMissionMutationMutation,
    ArchiveMissionMutationMutationVariables
  >({
    mutation: ArchiveMissionMutation,
    variables: {
      id: props.mission.prn,
      archivalReason: form.value.archivalReason,
    },
    done: () => {
      isSubmitting.value = false
    },
  })

  if (result?.data && !result?.data?.archiveMission.error) {
    addSuccess("Mission archived successfully")
    onCloseModal()
  }
}

const onCloseModal = () => {
  showArchiveMissionModal.value = false
  form.value.archivalReason = ""
}

return { __sfc: true,props, mutate, addSuccess, addError, isSubmitting, form, showArchiveMissionModal, onConfirmArchiveMission, onCloseModal, MissionLifecycleState, MissionAction }
}

})